export default "__VITE_ASSET__DnSuaqs3__"